import { values } from 'lodash';

import { DBDocSchema } from '../../legacy/objects/generic/db-doc/db-doc-schema';
import { GenericDisplayableSchema } from '../../legacy/objects/generic/displayable/generic-displayable-schema';
import { SchemaField } from '../../legacy/objects/generic/serialization/schema-field';

import { WidgetMode } from './widget-mode';

export class OrgSchema extends GenericDisplayableSchema {
  public static readonly widgetMode = 'widgetMode';
  public static readonly enableOnPaths = 'enableOnPaths';
  public static readonly canAttachToDOM = 'canAttachToDOM';
  public static readonly includedTrafficPercent = 'includedTrafficPercent';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[OrgSchema.widgetMode] = SchemaField.string(undefined)
      .valid(...values(WidgetMode))
      .required();

    parameters[OrgSchema.enableOnPaths] = SchemaField.arrayOfType(SchemaField.string(undefined), undefined).optional();
    parameters[OrgSchema.canAttachToDOM] = SchemaField.boolean(undefined).required();
    parameters[OrgSchema.includedTrafficPercent] = SchemaField.number(undefined).optional();

    return parameters;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Collection
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getCollection(_orgId: string): string {
    return `${DBDocSchema.GenericCollections.orgs}`;
  }
}
